import "./Login.scss"
import {useEffect, useState} from "react";
import {useFormik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import Icon, {eyeHideIcon, eyeShowIcon} from "../../components/Icon/Icon";
import dealydocs from "../../assets/dealydocs.png"
import {ReactComponent as logoSvg} from "../../assets/logo.svg";
import LoginActions from "../../api/LoginActions";
import useUser from "../../contexts/userContext/useUser";

const validationSchema = yup.object({
    email: yup.string().email("Invalid email").required("Email is required"),
    password: yup.string().required("Password is required")
});

const Login = () => {
    const navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const {login} = useUser();
    const [isPassword, setIsPassword] = useState(true);

    const decodeRole = (role) => {
        switch (role) {
            case "user":
                navigate("/forms");
                break;
            case "admin":
                navigate("/users");
                break;
            case "superadmin":
                navigate("/clients");
                break;
        }
    }

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: validationSchema,
        validateOnChange: false,
        onSubmit: (values, actions) => {
            if (!executeRecaptcha) {
                return;
            }

            executeRecaptcha("submit").then((recaptchaToken) => {
                const data = {
                    email: values.email,
                    password: values.password,
                    recaptchaToken: recaptchaToken
                }
                LoginActions.login(data, (result) => {
                    login({...result, email: data.email});

                    try {
                        const payload = result.token.split('.')[1];
                        const decodedPayload = JSON.parse(atob(payload));
                        decodeRole(decodedPayload.role);
                    } catch (error) {
                            return "user";
                    }

                }, () => {
                    actions.setStatus("Wrong data");
                    actions.setFieldError("email", " ");
                    actions.setFieldError("password", " ");
                })
            })
        }
    })


    useEffect(() => {
        LoginActions.me(user => decodeRole(user), error => {});
    }, []);

    return (
        <div className="login">
            <section className="card">
                <div className="header">
                    <Icon svg={logoSvg} className="logo"/>
                    <img src={dealydocs} alt="Dealydocs"/>
                </div>
                <form onSubmit={formik.handleSubmit}>
                    <Input
                        label="Email"
                        name="email"
                        type="email"
                        formik={formik}
                        className="modal"
                        required={false}
                    />

                    <div className="password">
                        <Input
                            label="Password"
                            name="password"
                            type={isPassword ? "password" : "text"}
                            formik={formik}
                            className="modal"
                            required={false}
                        />

                        <Icon
                            svg={isPassword ? eyeHideIcon : eyeShowIcon}
                            onClick={() => setIsPassword(!isPassword)}
                            className="eye"
                        />
                    </div>

                    <Button type="submit" className="sign-in">Sign In</Button>
                    {formik.status && <p className="credentials-error">Invalid credentials. Please try again.</p>}
                </form>
            </section>
        </div>
    )
}

export default Login;